var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
var switcherSports = [2, 31, 4, 6];
var Tracker = /** @class */ (function (_super) {
    __extends(Tracker, _super);
    function Tracker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () {
            _this.renderWidget();
        };
        _this.renderWidget = function () {
            var _a = _this.props, radarId = _a.radarId, sportId = _a.sportId;
            var config = {
                layout: "double",
                matchId: radarId,
            };
            if (switcherSports.includes(sportId)) {
                config.activeSwitcher = 'scoreDetails';
            }
            else {
                config.detailedScoreboard = 'disable';
            }
            window.SIR('addWidget', 'div.match-widget', 'match.lmtPlus', config);
        };
        return _this;
    }
    Tracker.prototype.render = function () {
        return _jsx("div", { className: "match-widget" });
    };
    return Tracker;
}(Component));
export default Tracker;



// WEBPACK FOOTER //
// ./src/components/grid/event/LiveMatchWidgets/Tracker.jsx